import { MouseEventHandler, ReactNode } from "react";
import { styles } from "./CounterBox.style";
import { linkStyles } from "../../../../shared/Button/Button.style";

export interface ICounterBoxProps {
  label?: string;
  value?: number;
  valueAdornment?: ReactNode;
  actionLink?: { url: string; label: string; onClick?: MouseEventHandler };
  hint?: string;
  testSelector?: string;
}

export const CounterBox = ({ label, value = 0, valueAdornment, actionLink, hint, testSelector }: ICounterBoxProps) => {
  return (
    <div className={styles.root()}>
      <div className={styles.label()}>{label}</div>
      <div className={styles.valueGroup()}>
        <div className={styles.value()} data-testid={testSelector}>
          {value}
        </div>
        {valueAdornment && <div className={styles.adornmentWrapper()}>{valueAdornment}</div>}
      </div>
      <div className={styles.linkContainer()}>
        {!actionLink && hint ? (
          <span className={styles.hint()}>{hint}</span>
        ) : (
          <a className={linkStyles} href={actionLink?.url} onClick={actionLink?.onClick}>
            {actionLink?.label}
          </a>
        )}
      </div>
    </div>
  );
};
